import Button from "components/common/Button/Button";
import Checkbox from "components/common/Checkbox/Checkbox";
import styled from "themes";
import theme from "themes/simple-theme-vh";

export const TermsAndConditionsText = styled.p`
  font-size: ${theme.fontSize.ms};
  font-family: ${theme.fontFamily.regular};
`;

export const TermsAndConditionsContainer = styled.div`
  background: ${theme.color.white};
  border-radius: ${theme.global.radius};
  padding: 4.4rem 4rem;
  width: 70vw;
  display: table;
`;

export const TermsAndConditionsButton = styled(Button)`
  width: 150px;
  margin-left: 14px;
`;

export const TermsAndConditionsCheckbox = styled(Checkbox)`
  align-items: end !important;
  margin-bottom: 30px !important;
`;

export const Link = styled.span`
  text-decoration: underline;
  font-weight: bold;
  z-index: 3;
`;

export const ScrollableText = styled.div`
  overflow-scrolling: touch;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll !important;
  min-height: 30vh;
  padding: 43px;
`;

export const CloseButton = styled.button`
  background: none;
  z-index: 10;
  border: none;
  padding: 0px 0;
  margin: 0;
  margin-left: -5px;
  position: fixed;
`;



// WEBPACK FOOTER //
// ./src/screens/Onboarding/WelcomeBoard/TermsAndConditions/TermsAndConditions.style.tsx